import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'anf-core-react';

export default function FieldTitle({
  title,
  titleTextKey,
  optionalText,
  optionalTextKey,
  subText,
  subTextKey,
  headingLevel = 'h4', // Default to h4 if no heading level is provided
  icon,
}) {
  return (
    <div className="field-title" data-testid="field-title" style={{ marginBottom: '15px' }} aria-hidden>
      <p className="field-title-text">
        {icon && (
        <span className="field-title-icon">
          <Icon icon={icon} size="s" />
        </span>
        )}
        <span className={headingLevel} data-text-key={titleTextKey}>{title}</span>
        {optionalText && (
          <>
            {' ('}
            <span data-text-key={optionalTextKey}>{optionalText}</span>
            )
          </>
        )}
      </p>
      {subText && (
        <p className="sub-text" style={{ marginTop: '5px' }} data-text-key={subTextKey}>
          {subText}
        </p>
      )}
    </div>
  );
}

FieldTitle.defaultProps = {
  titleTextKey: undefined,
  optionalText: undefined,
  optionalTextKey: undefined,
  subText: undefined,
  subTextKey: undefined,
  headingLevel: 'h4', // Default heading level
  icon: undefined, // Default to no icon
};

FieldTitle.propTypes = {
  title: PropTypes.node.isRequired,
  titleTextKey: PropTypes.string,
  optionalText: PropTypes.string,
  optionalTextKey: PropTypes.string,
  subText: PropTypes.string,
  subTextKey: PropTypes.string,
  headingLevel: PropTypes.string, // Accepts any valid HTML heading level (h1, h2, h3, etc.)
  icon: PropTypes.string, // Accepts the icon name as a string
};
